import React, { useEffect } from "react"
import CaseHeader from "../../features/case-header"
import TechnologiesList from "../../features/technologies-list"
import PythonLogo from "../../assets/images/technologies/Python.svg"
import ReactLogo from "../../assets/images/technologies/React.svg"
import AWSLogo from "../../assets/images/technologies/aws.svg"
import DjangoLogo from "../../assets/images/technologies/django2.svg"
import CeleryLogo from "../../assets/images/technologies/celery.svg"
import PostgreLogo from "../../assets/images/technologies/postgresql.svg"
import SendgridLogo from "../../assets/images/technologies/sendgrid.svg"

import CaseProjectBlock from "../../features/case-project-block"
import { DEVELOPERS_LIST_ORBIT } from "../../data/cases/developers-data"
import CaseDeveloper from "../../features/case-developer"
import CasesSays from "../../features/cases-client"

import { OUR_CLIENTS } from "../../data/home/our-clients"
import { ORBIT } from "../../data/cases/seo-says"
import ChallengesSolutions from "../../features/challenges-solutions"
import { CHALLENGES_LIST_ORBIT } from "../../data/cases/challenges-data"
import { SOLUTIONS_LIST_ORBIT } from "../../data/cases/solutions-data"
import { HEADER_ORBIT } from "../../data/cases/headers-data"
import { PROJECT_ORBIT } from "../../data/cases/project-data"
import { OtherCases } from "../../features/other-cases"
import { useMediaQuery } from "react-responsive"
import { DESKTOP_WIDTH } from "../../constants/common"
import "./index.scss"
import { Helmet } from "react-helmet-async"

const Orbit = () => {
    const isDesktop = useMediaQuery({ minWidth: DESKTOP_WIDTH })

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet defer={false}>
                <title>Newsoft - Orbit</title>
            </Helmet>            
            <div className="try-now">
                <CaseHeader {...HEADER_ORBIT} />
                <div className="try-now-image">
                    <img
                        src="https://newsoft-ns.com/media/orbit_case/Orbit.webp"
                        alt="Orbit main"
                    />
                </div>
                <TechnologiesList title="Key technologies">
                    <img
                        src={PythonLogo}
                        alt="Python logo"
                        style={isDesktop ? { width: "50px" } : {width: "40px"}}
                    />
                    <img
                        src={PostgreLogo}
                        alt="Postgre logo"
                        style={!isDesktop ? { width: "180px" } : {}}
                    />
                    <img
                        src={SendgridLogo}
                        alt="Sendgrid logo"
                        style={!isDesktop ? { width: "137px" } : {}}
                    />
                    <img
                        src={AWSLogo}
                        alt="AWS logo"
                        style={isDesktop ? { width: "68px" } : {}}
                    />
                    <img
                        src={ReactLogo}
                        alt="React logo"
                        style={!isDesktop ? { width: "50px" } : {}}
                    />
                    <img
                        src={DjangoLogo}
                        alt="Django logo"
                        style={isDesktop ? { width: "100px" } : {}}
                    />
                    <img
                        src={CeleryLogo}
                        alt="Celery logo"
                        style={!isDesktop ? { width: "50px" } : {}}
                    />
                </TechnologiesList>
                <CaseProjectBlock {...PROJECT_ORBIT} />
                <CasesSays
                    data={OUR_CLIENTS[2]}
                    header="What our client says"
                />
                <div className="try-now-developers">
                    <h2 className="t-s3 desk">developer quotes</h2>
                    {DEVELOPERS_LIST_ORBIT.map((el, id) => (
                        <CaseDeveloper
                            key={el.name}
                            {...el}
                            header={id === 0 && "developer quotes"}
                        />
                    ))}
                </div>
                <CasesSays
                    more
                    ceo={true}
                    data={ORBIT}
                    header="What our CEO says"
                />
                <ChallengesSolutions
                    challenges={CHALLENGES_LIST_ORBIT}
                    solutions={SOLUTIONS_LIST_ORBIT}
                />
                <div className="try-now-practice">
                    <h1 className="t-s3">Powerful Practice</h1>
                    <p className="t-b4">
                        The development and testing of the product took 24/7 and
                        this is a powerful practice . One half of the day worked
                        Ukrainian team, and the other - the American team.
                    </p>
                </div>
                <OtherCases currentCase="/cases/orbit" />
            </div>
        </>
    )
}

export default Orbit
